module.exports = __webpack_public_path__ + "static/img/banner.b00085c1.jpg";